import { Div } from "../../../../../../components/div/Div"
import { Span } from "../../../../../../components/span/Span"
import { styled, theme } from "../../../../../../styles/stitches.config"

export const DataTariffCard = styled(Div, {
  flex: "initial",
  "@md": {
    flex: 1,
  },
  borderRadius: "19px",
  paddingLeft: theme.space.s2_5,
  paddingTop: theme.space.s9,
  paddingBottom: theme.space.s9,
  paddingRight: theme.space.s3,
  transition: "0.3s",

  variants: {
    selected: {
      true: {
        border: `2px solid ${theme.colors.secondary}`,
      },
      false: {
        border: `2px solid ${theme.colors.lines}`,
      },
    },
  },
  defaultVariants: {
    selected: false,
  },
})

export const TextHighlight = styled(Span, {
  fontWeight: "bold",
  whiteSpace: "nowrap",

  variants: {
    noBreak: {
      true: {
        whiteSpace: "nowrap",
      },
      false: {
        whiteSpace: "initial",
      },
    },
    color: {
      primary: {
        color: theme.colors.primary,
      },
      secondary: {
        color: theme.colors.secondary,
      },
    },
  },

  defaultVariants: {
    noBreak: false,
    color: "secondary",
  },
})

export const Tooltip = styled(Div, {
  maxWidth: 464,
})

export const ProductLabel = styled(Div, {
  flex: "initial",
  "@md": { flex: 1 },
})

export const DesktopOnlyBr = styled("br", {
  display: "none",
  "@lg": {
    display: "initial",
  },
})

export const DesktopOnlySpacer = styled("div", {
  height: theme.space.s8,
  width: theme.space.s8,
  minHeight: theme.space.s8,
  minWidth: theme.space.s8,

  display: "none",
  "@md": {
    display: "initial",
  },
})
